import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { testId } from 'ui-components/services/testid-service';

import style from '../style.module.less';

const Quantity = ({ quantity = 0 }) => {
  const quantityWrapperClassnames = classnames(style['quantity-wrapper'], {
    [style['greater-than-two']]: quantity > 1,
    [style['has-four-digits']]: quantity > 999,
  });
  return (
    <div className={style['item-price-quantity']}>
      <div className={quantityWrapperClassnames}>
        <div className={style.quantity} {...testId('item-quantity')}>
          <div className={style.number}>
            <FormattedNumber value={quantity} />
          </div>
        </div>
      </div>
    </div>
  );
};

Quantity.propTypes = {
  quantity: PropTypes.number,
};

export default Quantity;
